module.exports = __webpack_public_path__ + "static/giraffeanimal1-e1d54c530ddfb131fe73def0e1af6363.png";